// extracted by mini-css-extract-plugin
export default {"navbarItem":"NavbarItem_navbarItem__PYAgI","active":"NavbarItem_active__ReQEE"};